import { render, staticRenderFns } from "./ClientModal.vue?vue&type=template&id=2b8cbe84"
import script from "./ClientModal.vue?vue&type=script&lang=js"
export * from "./ClientModal.vue?vue&type=script&lang=js"
import style0 from "./ClientModal.vue?vue&type=style&index=0&id=2b8cbe84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports